import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class PropertyCodeLookupService {

    static getPropertyCodes(lob, jobNumber, previousClassCode, address, sessionUUID, coverageForm, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('propertycode'),
            'getPropertyCodes',
            [lob, jobNumber, previousClassCode, address, sessionUUID, coverageForm],
            additionalHeaders
        );
    }
}